'use client';

import Image from 'next/image';
import { useMemo, useState } from 'react';
import { canOptimizeImage } from '@/lib/utils';

export default function ProjectImage({ project }) {
  const [imageIndex, setImageIndex] = useState(0);

  const imageUrl = useMemo(() => {
    if (!project?.images) {
      return null;
    }
    const abs = Math.abs(imageIndex);
    const mod = abs % project?.images?.length || 0;
    const i =
      imageIndex < 0
        ? project?.images?.length - mod - 1
        : imageIndex % project?.images?.length || 0;
    return project?.images[i] || null;
  }, [imageIndex, project.images]);

  if (!(project && imageUrl)) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center w-full">
      <div className="relative group">
        <div className="absolute flex h-full w-full px-1 justify-between items-center invisible group-hover:visible">
          <a className="btn btn-circle" onClick={() => setImageIndex((idx) => (idx -= 1))}>
            ❮
          </a>
          <a className="btn btn-circle" onClick={() => setImageIndex((idx) => (idx += 1))}>
            ❯
          </a>
        </div>
        <Image
          className="rounded"
          src={imageUrl}
          height={350}
          width={350}
          unoptimized={!canOptimizeImage(imageUrl)}
          alt={`Sample image from ${project.name || 'this'} collection`}
        />
      </div>
      {/* // If we want buttons below
      <div className="flex justify-center w-full py-2 gap-2">
        {project?.images?.map((url, i) => (
          <a
            key={`${project.id}-button-${url}`}
            onClick={() => setImageIndex(i)}
            className="btn btn-xs"
          >
            {i + 1}
          </a>
        ))}
      </div>
      */}
    </div>
  );
}
